module.exports = __webpack_public_path__ + "52f04458189a382583d7815fdc56a176.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-large.jpg
// module id = 350
// module chunks = 0